import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    name: 'Caspian Voss',
    role: 'CMO at OddsForge',
    quote: 'Steelserieshub transformed our affiliate program from a cost center into our primary revenue engine. €1.2M in tracked commissions within 8 months.'
  }, {
    name: 'Thessaly Kade',
    role: 'Director at WagerPulse',
    quote: 'Their SEO strategy took us from page 4 to position 2 for our highest-value keywords. The ROI speaks for itself.'
  }, {
    name: 'Leander Brune',
    role: 'Founder of StakeLine',
    quote: 'The compliance-first approach saved us from two potential regulatory issues while actually improving our rankings.'
  }];
  return <section id="results" className="py-20 bg-[#0d2818]" data-id="element-185">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-186">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-187">
          <h2 className="text-3xl sm:text-4xl font-bold mb-4" data-id="element-188">
            <span className="text-[#00ff88]" data-id="element-189">Verified</span> Wins
          </h2>
          <p className="text-gray-400 text-lg" data-id="element-190">
            What our partners say about working with Steelserieshub
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-191">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-[#0a1a0f] border-2 border-dashed border-[#00ff88]/30 rounded-lg p-6 hover:border-[#00ff88]/60 transition-colors" data-id="element-192">
              <Quote className="text-[#00ff88] mb-4" size={32} data-id="element-193" />
              <p className="text-gray-300 mb-6 italic" data-id="element-194">"{testimonial.quote}"</p>
              <div className="border-t border-[#00ff88]/20 pt-4" data-id="element-195">
                <div className="font-bold font-mono text-sm" data-id="element-196">
                  {testimonial.name}
                </div>
                <div className="text-gray-400 text-xs mt-1" data-id="element-197">
                  {testimonial.role}
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}